<template>
  <multiselect 
    placeholder="Select Area"
    :options="areas.data" 
    label="areaname" 
    track-by="id" 
    :value="selected" 
    @input="handleInput" 
    @remove="handleRemove">
    <template slot="option" slot-scope="props">
      <div>{{ props.option.areaname }}</div>
      <div class="mt-1 text-sm text-gray-500 ">{{ props.option.areano }}</div>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'AreaSelect',

  components: {
    Multiselect
  },

  created () {
    this.getAreas()
  },

  props: ['value'],

  computed: {
    selected () {
      return this.areas.data.find(area => area.id === this.value)
    }
  },

  data () {
    return {
      areas: {
        data: []
      }
    }
  },

  methods: {
    async getAreas () {
      try {
        const { data } = await this.$api.get(`account/${this.$route.params.account}/areas`, {
          params: {
            page: this.$route.query.page || 1,
            limit: 500
          }
        })
        this.areas = data.areas
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },

    handleInput (value) {
      this.$emit('input', value.id)
    },

    handleRemove () {
      this.$emit('input', null)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>